////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const columns = {
	[ActionsTypes.SET_COLUMNS]: (state, payload) => {
		return update(state, {
			columns: {
				col: {
					$set: payload.col,
				},
			},
		})
	},
	[ActionsTypes.SET_TABLE_HEIGHT]: (state, payload) => {
		return update(state, {
			columns: {
				height: {
					$set: payload.height,
				},
			},
		})
	},
	[ActionsTypes.SET_IS_EDITING_TRIGGER]: (state, _payload) => {
		return update(state, {
			columns: {
				isEditingTrigger: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.SET_IS_EDITING_NOT_TRIGGER]: (state, _payload) => {
		return update(state, {
			columns: {
				isEditingTrigger: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.SET_IS_VALIDATE_ENABLE]: (state, _payload) => {
		return update(state, {
			columns: {
				isValidateEnable: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.SET_IS_RESET_FORM]: (state, _payload) => {
		return update(state, {
			columns: {
				isResetForm: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.SET_FORM_BUTTON_WIDTH]: (state, payload) => {
		return update(state, {
			columns: {
				formButtonWidth: {
					$set: payload.value,
				},
			},
		})
	},
	[ActionsTypes.SET_IS_SINGLE_EDIT]: (state, payload) => {
		return update(state, {
			columns: {
				isSingleEdit: {
					$set: payload.bool,
				},
			},
		})
	},
	[ActionsTypes.SET_IS_SEARCHFIELD_UPDATED]: (state, payload) => {
		return update(state, {
			columns: {
				isSearchfieldUpdated: {
					$set: payload.bool,
				},
			},
		})
	},
	[ActionsTypes.SET_CURRENT_COLUMN]: (state, payload) => {
		return update(state, {
			columns: {
				currentColumn: {
					$set: payload,
				},
			},
		})
	},
	[ActionsTypes.SET_CURRENT_DIR]: (state, payload) => {
		return update(state, {
			columns: {
				currentDir: {
					$set: payload,
				},
			},
		})
	},
}

export default columns
